import { isEmpty } from 'lodash';
import { HttpErrorResponse } from '@angular/common/http';

import {
  IErrorOverride,
  XEAConnectionError,
  XEAError,
} from '@app/shared/types';
import { I18nService } from '../i18n/i18n.service';

export class HttpErrorHandler {
  public static composeError(
    httpError: HttpErrorResponse,
    options: {
      errorOverride?: IErrorOverride;
      i18nService: I18nService;
    },
  ): XEAError {
    const statusCode = httpError.status;
    const { errorOverride, i18nService } = options;

    if (statusCode === 0) {
      return new XEAConnectionError({
        errorMessage: errorOverride?.commonError,
        i18nService,
      });
    }

    if (!isEmpty(errorOverride?.apiError)) {
      return new XEAConnectionError({
        errorMessage: errorOverride?.apiError,
        i18nService,
      });
    }

    return httpError.error;
  }
}
